module.exports = "<div class=\"popover sma-dropselect-popover-wrapper\" role=\"tooltip\">\n   <div class=\"popover-arrow\"></div>\n   <div class=\"popover-content\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/sma.admin/components/dropdowns/partials/popover_wrapper.html
// module id = 1577
// module chunks = 17